export const questionnaireKeys = {
  all: ["questionnaire"] as const,
  definitions: () => [...questionnaireKeys.all, "definitions"] as const,
  definition: (slug: string) =>
    [...questionnaireKeys.definitions(), slug] as const,
  instances: (contextType: string, contextId: string) =>
    [...questionnaireKeys.all, "instances", contextType, contextId] as const,
  latestInstance: (
    contextType: string,
    contextId: string,
    questionnaireSlug?: string
  ) =>
    [
      ...questionnaireKeys.all,
      "instances",
      contextType,
      contextId,
      "latest",
      questionnaireSlug,
    ] as const,
};
